<template>
  <h2 class="font-weight-bold text-uppercase text-center mt-6">
    {{ msg }}
  </h2>
</template>

<script>
export default {
  name: "Title",
  props: {
    msg: {
      type: String,
      required: false,
    },
  },
};
</script>

<style></style>
